import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Card from '@mui/material/Card';
import { prefetchMasterData } from '../../utils/prefetchMasterData';
import DepartmentsTab from './DepartmentsTab';
import MaterialGroupsTab from './MaterialGroupsTab';
import MaterialsTab from './MaterialsTab';
import MakesTab from './MakesTab';
import PriceChangeBasisTab from './PriceChangeBasisTab';
import TypeOfInstallationTab from './TypeOfInstallationTab';
import AccessoryGroupsTab from './AccessoryGroupsTab';
import AccessoriesTab from './AccessoriesTab';

/**
 * Lazy-mount keep-alive: each tab mounts the first time it is visited and
 * stays mounted (hidden with CSS) for all subsequent visits.
 *
 * Benefits vs the old {tab === N && <Component />} pattern:
 *  - No expensive unmount/remount on tab switch
 *  - Filter state, scroll position, selection survive tab switches
 *  - Cache + component state both preserved
 *  - Initial paint: only the first tab mounts, others are lazy
 */
function TabPanel({ value, activeTab, children }) {
  const [everMounted, setEverMounted] = useState(value === activeTab);
  if (!everMounted && value === activeTab) setEverMounted(true);
  if (!everMounted) return null;
  return (
    <Box sx={{ display: value === activeTab ? 'block' : 'none' }}>
      {children}
    </Box>
  );
}

export default function MasterData() {
  const [tab, setTab] = useState(0);

  // Start fetching all tab data the moment this page mounts — before the user
  // has clicked anything.  By the time they click Materials or Accessories the
  // API response is already in the cache and the tab renders instantly.
  useEffect(() => { prefetchMasterData(); }, []);

  return (
    <Box>
      <Card>
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ borderBottom: 1, borderColor: 'divider', px: 2 }}
        >
          <Tab label="Departments" />
          <Tab label="Material Groups" />
          <Tab label="Materials" />
          <Tab label="Makes" />
          <Tab label="Price Change Basis" />
          <Tab label="Type of Installation" />
          <Tab label="Accessory Groups" />
          <Tab label="Accessories" />
        </Tabs>
        <Box sx={{ p: 3 }}>
          <TabPanel value={0} activeTab={tab}><DepartmentsTab /></TabPanel>
          <TabPanel value={1} activeTab={tab}><MaterialGroupsTab /></TabPanel>
          <TabPanel value={2} activeTab={tab}><MaterialsTab /></TabPanel>
          <TabPanel value={3} activeTab={tab}><MakesTab /></TabPanel>
          <TabPanel value={4} activeTab={tab}><PriceChangeBasisTab /></TabPanel>
          <TabPanel value={5} activeTab={tab}><TypeOfInstallationTab /></TabPanel>
          <TabPanel value={6} activeTab={tab}><AccessoryGroupsTab /></TabPanel>
          <TabPanel value={7} activeTab={tab}><AccessoriesTab /></TabPanel>
        </Box>
      </Card>
    </Box>
  );
}
